'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _lodash = require('lodash');

var _app = require('./../../../app.misc');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TargetsOverviewController = function () {
  function TargetsOverviewController(authService, enums, lookupService, userService, $scope, loadingService, reportingService, performanceManagementService, utilsService) {
    "ngInject";

    //Services Begin

    var _this = this;

    (0, _classCallCheck3.default)(this, TargetsOverviewController);
    this.authService = authService;
    this.enums = enums;
    this.lookupService = lookupService;
    this.userService = userService;
    this.$scope = $scope;
    this.loadingService = loadingService;
    this.reportingService = reportingService;
    this.performanceManagementService = performanceManagementService;
    this.utilsService = utilsService;
    //Servies End

    //Begin Data
    this.dateRangeList = [];
    this.brands = [];
    this.allBrandModels = [];
    this.userLocations = [];
    this.userList = [];

    this.reportCriteria = {};

    this.dtPopups = {};

    this.panels = {
      reportCriteria: true,
      reportData: false
    };
    //End Data

    this.initializeLookups().then(function () {
      _this.getDateRangeList();
      _this.getUserLocations();
      _this.getVehicleConditionList();

      _this.reset();
    });
  }

  (0, _createClass3.default)(TargetsOverviewController, [{
    key: 'initializeLookups',
    value: function initializeLookups() {
      var _this2 = this;

      var ctrl = this;
      var promise = this.lookupService.lookupBrands();

      promise.then(function (brands) {
        _this2.brands = brands;

        _this2.lookupService.lookupBrandModels().then(function (brandModels) {
          _this2.allBrandModels = brandModels;
        });
      });

      return promise;
    }
  }, {
    key: 'updateBrandModel',
    value: function updateBrandModel() {
      var _this3 = this;

      this.brandModels = (0, _lodash.filter)(this.allBrandModels, function (o) {
        return o.brandId === _this3.reportCriteria.brand.brandId;
      });
      this.brandModels.unshift({ id: null, name: 'All' });
      this.reportCriteria.brandModel = this.brandModels[0];
    }
  }, {
    key: 'getDateRangeList',
    value: function getDateRangeList() {
      this.dateRangeList.push({ id: this.enums.DATE_RANGE_TYPE['This Month'], name: 'This Month' });
      this.dateRangeList.push({ id: this.enums.DATE_RANGE_TYPE['This Quarter'], name: 'This Quarter' });
      this.dateRangeList.push({ id: this.enums.DATE_RANGE_TYPE['Last Month'], name: 'Last Month' });
      this.dateRangeList.push({ id: this.enums.DATE_RANGE_TYPE['Last Quarter'], name: 'Last Quarter' });
      this.dateRangeList.push({ id: this.enums.DATE_RANGE_TYPE['This Year'], name: 'This Year' });
      this.dateRangeList.push({ id: this.enums.DATE_RANGE_TYPE['Custom'], name: 'Custom' });
    }
  }, {
    key: 'getUserLocations',
    value: function getUserLocations() {
      this.userLocations = this.authService.authData.userLocations.map(function (l) {
        return { id: l.key, name: l.value };
      });

      this.userLocations.unshift({ id: null, name: 'All' });
    }
  }, {
    key: 'getVehicleConditionList',
    value: function getVehicleConditionList() {
      this.vehicleConditionList = (0, _app.convertEnumToKeyValueList)(this.enums.VEHICLE_CONDITION);
    }
  }, {
    key: 'reset',
    value: function reset() {
      this.$scope.$broadcast('kpiAnalytics:reset');

      this.errMsgs = [];

      this.reportCriteria.dateRangeOption = this.dateRangeList[0];
      this.reportCriteria.vehicleCondition = this.vehicleConditionList[0];
      this.reportCriteria.startDate = new Date();
      this.reportCriteria.endDate = new Date();
      this.reportCriteria.location = this.userLocations[0];
      this.reportCriteria.brand = this.brands[0];

      this.updateUserList();
      this.updateBrandModel();
    }
  }, {
    key: 'updateDateRange',
    value: function updateDateRange() {
      var _this4 = this;

      this.loadingService.showLoading('reportCriteria', 'Updating Criteria ...');

      this.reportingService.getDateRange(this.reportCriteria.dateRangeOption.id).then(function (response) {
        response.data.startDate = _this4.utilsService.getReportStartDate(_this4.reportCriteria.dateRangeOption.id, response.data.startDate);
        response.data.endDate = _this4.utilsService.getReportEndDate(_this4.reportCriteria.dateRangeOption.id, response.data.endDate);

        _this4.reportCriteria.startDate = response.data.startDate ? new Date(response.data.startDate) : null;
        _this4.reportCriteria.endDate = response.data.endDate ? new Date(response.data.endDate) : null;
      }).finally(function () {
        _this4.loadingService.hideLoading('reportCriteria');
      });
    }
  }, {
    key: 'updateUserList',
    value: function updateUserList() {
      var _this5 = this;

      this.loadingService.showLoading('reportCriteria', 'Updating Criteria ...');

      this.userService.getEntityUsers(this.getLocationIds()).then(function (response) {
        _this5.userList = response.data.map(function (i) {
          return { id: i.userId, name: i.firstName + ' ' + i.lastName };
        });
        _this5.userList.unshift({ id: null, name: 'All' });

        _this5.reportCriteria.user = _this5.userList[0];
      }).finally(function () {
        _this5.loadingService.hideLoading('reportCriteria');
      });
    }
  }, {
    key: 'getLocationIds',
    value: function getLocationIds() {
      var locationIds = void 0;

      if (!this.reportCriteria.location.id) {
        locationIds = (0, _lodash.filter)(this.userLocations, function (o) {
          return o.id;
        }).map(function (ul) {
          return ul.id;
        });
      } else {
        locationIds = [this.reportCriteria.location.id];
      }

      return locationIds;
    }
  }, {
    key: 'showDatePopup',
    value: function showDatePopup(fieldName) {
      this.dtPopups[fieldName] = true;
    }
  }, {
    key: 'viewAnalytics',
    value: function viewAnalytics() {
      var _this6 = this;

      if (!this.validateCriteria()) {
        return;
      }

      this.loadingService.showLoading('reportData', 'Running Report ...');

      this.performanceManagementService.getTargetsOverview(this.parseCriteria()).then(function (response) {
        _this6.$scope.$broadcast('kpiAnalytics:targetsOverviewUpdated.enquiriesCreated', { target: response.data.enquiriesCreatedTarget, achieved: response.data.enquiriesCreated });
        _this6.$scope.$broadcast('kpiAnalytics:targetsOverviewUpdated.enquiriesDelivered', { target: response.data.enquiriesDeliveredTarget, achieved: response.data.enquiriesDelivered });
      }).finally(function () {
        _this6.loadingService.hideLoading('reportData');
      });
    }
  }, {
    key: 'validateCriteria',
    value: function validateCriteria() {
      this.errMsgs = [];

      if (!this.reportCriteria.startDate) {
        this.errMsgs.push('Please provide a Start Date');
      }

      if (!this.reportCriteria.endDate) {
        this.errMsgs.push('Please provide an End Date');
      }

      if (this.reportCriteria.endDate && this.reportCriteria.startDate > this.reportCriteria.endDate) {
        this.errMsgs.push('Start Date can not be greater than End Date');
      }

      return this.errMsgs.length === 0;
    }
  }, {
    key: 'parseCriteria',
    value: function parseCriteria() {
      var parsedCriteria = {};

      parsedCriteria.vehicleCondition = this.reportCriteria.vehicleCondition.id;
      parsedCriteria.startDate = this.reportCriteria.startDate.toISOString();
      parsedCriteria.endDate = this.reportCriteria.endDate.toISOString();
      parsedCriteria.locationIds = this.getLocationIds();
      parsedCriteria.salesRepId = this.reportCriteria.user.id;
      parsedCriteria.brandId = this.reportCriteria.brand.brandId;
      parsedCriteria.brandModelId = this.reportCriteria.brandModel.brandModelId;

      return parsedCriteria;
    }
  }]);
  return TargetsOverviewController;
}();

exports.default = TargetsOverviewController;


// WEBPACK FOOTER //
// ./client/app/components/kpiAnalytics/targetsOverview/targetsOverview.controller.js